import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-badge',
  standalone: false,
  templateUrl: './system-badge.component.html',
})
export class SystemBadgeComponent {
  @Input({ required: true }) systemName: string;
}
